module.exports = __webpack_public_path__ + "static/media/info_filled_blue.6996a38b.svg";